module.exports = __webpack_public_path__ + "officialStatic/img/auth4.65f3fe1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/auth4.jpg
// module id = ++EE
// module chunks = 0